module.exports = __webpack_public_path__ + "static/media/C24.c558c1ce.png";